import styled from "styled-components";

export const UpdateGatewayInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    box-sizing: border-box;
`;

export const TitleWrapper = styled.div`
    flex: 0 0 auto;
    margin: 10px 0px;
`;

export const Title = styled.div`
    font-size: 18px;
`;

export const FormWrapper = styled.div`
    flex: 1 1 auto;
`;

export const UploadIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 10px;

    & span {
        font-size: 48px;
        color: #1677FF;
    }
`;

export const OperationWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 10px 0px;
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    padding: 5px 0px;

    & .ant-form-item {
        flex: 1 1 0;
        padding-right: 10px;
        box-sizing: border-box;
        min-width: 0px;
    }

    & .ant-form-item-label {
        padding-left: 5px !important;
    }

    & .ant-picker {
        width: 100%;
    }
`;

export const MapPickerWrapper = styled.div`
    flex: 1 1 auto;
    height: 250px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
`;
